import { z } from 'zod';

/**
 * Validation schema for the B2B "Apply to Join" lead form. Shared by the
 * client form (react-hook-form resolver) and the server action so the contract
 * stays in one place. Field names match the `name` attributes posted to
 * {@link B2B_LEAD_API_ROUTE}.
 */
export const leadFormSchema = z.object({
    firstName: z.string().trim().min(1, 'First name is required'),
    lastName: z.string().trim().min(1, 'Last name is required'),
    businessName: z.string().trim().min(1, 'Business name is required'),
    businessWebsite: z.string().trim().min(1, 'Business website is required'),
    email: z
        .string()
        .trim()
        .min(1, 'Email is required')
        .email('Enter a valid email'),
    phone: z.string().trim().min(1, 'Phone is required'),
    jobTitle: z.string().trim().min(1, 'Job title is required'),
    industry: z.string().trim().min(1, 'Please select an industry'),
    state: z.string().trim().min(1, 'Please select a state'),
    city: z.string().trim().min(1, 'Please select a city'),
    message: z.string().trim().optional(),
});

export type LeadFormValues = z.infer<typeof leadFormSchema>;

export const LEAD_FORM_DEFAULT_VALUES: LeadFormValues = {
    firstName: '',
    lastName: '',
    businessName: '',
    businessWebsite: '',
    email: '',
    phone: '',
    jobTitle: '',
    industry: '',
    state: '',
    city: '',
    message: '',
};
